module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "dateFields": _vm.dateFields,
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Refresh Dashboard'),
      expression: "'Refresh Dashboard'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "btn btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-refresh"
  })])]) : _vm._e(), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-icon",
    class: {
      filtered: _vm.showLeadsTable
    },
    on: {
      "click": function($event) {
        _vm.showLeadsTable = !_vm.showLeadsTable
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table",
    class: {
      'with-leads-table-active': _vm.showLeadsTable
    },
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "col-xs-12 spinner-container"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dashboard.name) ? _c('h1', [_vm._v(_vm._s(_vm.dashboard.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 ls-charts-wrapper"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.dashboard.components.length) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.dashboard.components,
      "col-num": 6,
      "row-height": 60,
      "vertical-compact": true,
      "margin": [10, 10],
      "use-css-transforms": false,
      "responsive": false,
      "auto-size": true
    }
  }, _vm._l((_vm.dashboard.components), function(item, index) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "static": true,
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.id
      }
    }, [_c('component-box', {
      attrs: {
        "width": item.w,
        "height": item.h,
        "component": item,
        "index": index,
        "datesRange": _vm.datesRange,
        "isEditable": false
      }
    })], 1)
  }), 1)], 1)]) : _vm._e()])])]), _vm._v(" "), (_vm.showLeadsTable) ? _c('div', {
    staticClass: "row ls-leads-table"
  }, [_c('div', {
    staticClass: "col-xs-12 leads-queue-wrapper"
  }, [_c('div', {
    staticClass: "box panel leads-queue full-height"
  }, [_c('div', {
    staticClass: "panel-content chart-wrapper full-height"
  }, [_c('div', {
    staticClass: "endless-table-container full-height"
  }, [_c('endless-table', {
    attrs: {
      "readOnly": true,
      "pickedColumns": _vm.pickedColumns,
      "isAdmin": _vm.isAdmin,
      "datesRange": _vm.datesRange,
      "showLeadsTable": _vm.showLeadsTable
    }
  })], 1)])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539721b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/Home.vue
// module id = 647
// module chunks = 0